<p>
    <img src="{{url}}" class="_topicImg" data-name="{{name}}" />
    <i class="icon iconfont icon-guanbi1 _removeTopicImg"></i>
</p>